// @ts-nocheck

import * as R from 'ramda';
import React, { Component } from 'react';
import Dropdown from '../Dropdown';
const BASELINE_OPTIONS = [
  {
    label: 'all attributed installs',
    value: 'all attributed installs',
  },
  {
    label: 'all paid advertising',
    value: 'all paid advertising',
  },
  {
    label: 'all non paid advertising',
    value: 'all non paid advertising',
  },
];
type Props = {
  baselines: Array<string>;
  updateBaselines: (arg0: Array<string>) => void;
};

class BaselineCompareBy extends Component<Props> {
  render() {
    const { baselines, updateBaselines } = this.props;
    return (
      <div className="analytics-filters__row">
        <span className="h_fw-600 h_ta-end h_mt-5">against baselines</span>
        <Dropdown
          multi={true}
          options={BASELINE_OPTIONS}
          value={baselines}
          onChange={(e) => updateBaselines(e.map(R.prop('value')))}
          outerClassName="h_mstart-10 h_w-40"
          testid="filter-cti-time__fraud-chart"
        />
      </div>
    );
  }
}

export default BaselineCompareBy;
